import axios from '@/services/axios'
import BaseModel from '@/shared/models/BaseModel'
import Prize from './Prize'

export default class Level extends BaseModel {

    defaults() {
        return {
            id            : '',
            name          : '',
            trigger_amount: '',
            description   : '',
            tos_url       : '',
            color         : '',
            icon_url      : '',
            next          : {},
            prev          : {},
        }
    }

    relationships() {
        return {
            prize: { class: Prize, defaultValue: {} },
        }
    }

    static async list(pagination) {
        let params = {}
        if (pagination) {
            params = {
                page    : pagination.page,
                per_page: pagination.perPage,
            }
        }

        const response = await axios({
            url: '/level',
            method: 'get',
            params,
        })

        if (!response || !response.data || response.status !== 200)
            return

        return response.data.map(level => new this(level))
    }
}